export default {
    dependencies: [
        '$element',
        '$controllerator',
        'trackingservice',
        'neighborhoodProfileService',
    ],
    callable(ele, controllerator, trackingService, neighborhoodProfileService) {
        const url = ele.getAttribute('data-nb-profile-url');
        window.addEventListener('scroll', loadNeighborhoodProfile, {
            once: true,
        });
        function loadNeighborhoodProfile() {
            neighborhoodProfileService(url)
                .then(handleSuccess)
                .catch(reason => {
                    const err = new Error(
                        `${reason.status} - Neighborhood profile could not be loaded: ${reason.responseURL}`
                    );
                    if (window.trackJs) {
                        window.trackJs.track(err);
                    } else {
                        window._trackJsErrorQueue =
                            window._trackJsErrorQueue || [];
                        window._trackJsErrorQueue.push(err);
                    }
                });
        }

        function handleSuccess(data) {
            ele.querySelector('[data-nb-profile]').innerHTML = data;
            addTracking(ele);
            controllerator.run();
        }

        function addTracking(ele) {
            const link = ele.querySelector('a');

            if (!link) {
                return;
            }
            link.addEventListener('click', function() {
                if (this.closest('[data-nb-ratings]')) {
                    trackingService.trackEvent(
                        'other.neighborhood-ratings-click',
                        'start',
                        ''
                    );
                } else {
                    trackingService.trackEvent(
                        'other.neighborhood-click',
                        'start',
                        ''
                    );
                }
            });
        }

        return {
            handleSuccess,
        };
    },
};



// WEBPACK FOOTER //
// ./controllers/neighborhoodProfile.js